<template>
  <div id="SectionReviews">
    <UIContainer class="SectionReviews__container">
      <SectionTitle class="SectionReviews__title">
        <template #title> Trusted by teams that can't afford rework </template>
        <template #description>
          Praised for clean audits, faster questionnaires, and zero spreadsheet
          drama.
        </template>
      </SectionTitle>

      <div class="SectionReviews__content">
        <div class="SectionReviews__overall">
          <div class="SectionReviews__overall-score">4.9/5</div>
          <StarRating class="SectionReviews__overall-stars" :rating="4.5" />
          <div class="SectionReviews__overall-label">avg. rating</div>
          <div class="SectionReviews__overall-score">150+</div>
          <div class="SectionReviews__overall-label">reviews</div>
        </div>

        <div class="SectionReviews__carousel">
          <ReviewCarousel />
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import StarRating from '@/views/components/ui/rating/UIStarRating.vue'
import ReviewCarousel from '@/views/components/misc/ReviewCarousel.vue'
</script>

<style lang="scss" scoped>
#SectionReviews {
  .SectionReviews__content {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    @include md {
      flex-direction: row;
      align-items: flex-start;
      margin-top: 4rem;
    }
  }

  .SectionReviews__overall {
    max-width: 13rem;
    width: 100%;
    display: flex;
    flex-direction: column;

    @include md {
      flex: 0 0 13rem;
    }
  }

  .SectionReviews__carousel {
    width: 100%;
    min-width: 0;

    @include md {
      margin-left: auto;
    }
  }

  .SectionReviews__overall-score {
    @include font-size-30px();
    font-weight: 600;
    color: $color-ui-brand-700;

    &:not(:first-child) {
      margin-top: 1.25rem;
    }

    @include md {
      @include font-size-60px();
    }
  }

  .SectionReviews__overall-stars {
    --size: 32px;
    width: 100%;
    height: 25px;
    margin-left: 0.375rem;
  }
  .SectionReviews__overall-label {
    margin-top: 0.25rem;
  }

  .SectionReviews__overall-cta {
    margin-top: auto;
  }
}
</style>
